import React, { useEffect, useRef, useState } from "react";
import { CiLocationOn } from "react-icons/ci";
import { AiOutlineMenu } from "react-icons/ai";
import { HiOutlineUser } from "react-icons/hi2";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from 'react-responsive';
import buyimg from "../../images/Buy.png"
import buy1img from "../../images/Buy1.png"
import logo from "../../../src/images/Logo.png";
import { useNavigate } from "react-router-dom";
import Pagedropdown from "./Pagedropdown";
import { FaUser } from "react-icons/fa";

import Search from "./Search";
import Sidebar from "./Sidebar";
import Modal from "./Modal";
import Mobileforms from "../Common/Mobileforms";
import Categorylist from "./Categorylist";
import CountryDropdown from "./CountryDropdown";
import { CurrentLocation } from "../Common";
import { setformmodal, setformstatus } from "../../redux/formslice";
import leftimg from "../../images/Arrow - Left 2.png"
import { trackCartClick } from "../utils/dataUserpush"
import driver from "../../images/iconoir_delivery-truck.png"
const Header = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isBigScreen = useMediaQuery({ query: '(min-width: 991px)' });
    const [isSidebarOpen, setSidebarOpen] = useState(false);

    const dropdownRef = useRef(null);

    const formmodal = useSelector(state => state.globalslice.formmodal);
    const countryDropdown = useSelector(state => state.globalslice.countryDropdown);
    const cartlistdata = useSelector(state => state.cartslice.cartlistdata);
    const addresslistdata = useSelector(state => state.addresslice.addresslistdata);
    const authstatus = useSelector(state => state.formslice.authstatus);
    const logindata = useSelector(state => state.formslice.logindata);
    const currentcountry = useSelector((state) => state.globalslice.currentcountry);
    const addressdata = addresslistdata?.data?.filter(ele => ele.default_address == 1);

    const loginclick = () => {
        dispatch(setformmodal(!formmodal));
        dispatch(setformstatus(1));
    };



    return (
        <div className="mainheader">

            {/* Middle Header */}
            <div className="header-middle-main primarybackground">
                <div className="header-middle homepagecontainer">
                    {/* Sidebar and Logo */}
                    <div className="companylogomain d-flex">
                        {!isBigScreen && (
                            <div onClick={() => setSidebarOpen(true)}>
                                <AiOutlineMenu size={20} className="me-1" style={{ marginTop: 2 }} />
                            </div>
                        )}
                        <Sidebar isOpen={isSidebarOpen} onClose={() => setSidebarOpen(false)} />
                        <NavLink to="/">
                            <img className="companylogo" src={logo} alt="logo" />
                        </NavLink>
                    </div>

                    {/* Search */}
                    {isBigScreen && <Search />}

                    {/* Location */}





                    {/* Right Side */}
                    <div className="header-middle-right">
                        {isBigScreen && (
                            <NavLink
                                to={authstatus ? "/address" : ""}
                                className="headertop-leftcorner delivertext cursor-pointer textdecoration-none"
                            >
                                <img src={'/assets/vector_icons/location.png'} className="headertop-icons" />
                                <span className="ps-1 headertoptitle">Deliver to</span>
                                {!authstatus ? (
                                    <CurrentLocation />
                                ) : (
                                    <span className="ps-1 currentlocation-address">
                                        {addressdata?.[0]?.address}
                                    </span>
                                )}
                            </NavLink>
                        )}

                        {isBigScreen &&
                            <CountryDropdown countryDropdown={countryDropdown} />
                        }

                        {/* User */}
                        {!authstatus ? (
                            <div className="header-middle-rightsub pe-4 cursor-pointer" onClick={loginclick}>
                                <div className="cursor-pointer  flex usermain items-center">
                                    <FaUser size={16} />
                                    <span className="ps-2 header-middle-right-title username">Login</span>
                                </div>
                            </div>
                        ) : (
                            <Pagedropdown logindata={logindata} />
                        )}
                        {/* Cart */}
                        <NavLink
                            to="/cart"
                            className={`header-middle-rightsub d-flex cart-hover text-decoration-none ${cartlistdata?.data?.result?.length > 0 ? 'cart-not-empty' : ''
                                }`}
                            onClick={trackCartClick(currentcountry.name)}
                        >
                            <div className="headercart-icon">
                                {/* Show when cart is empty */}
                                {(!cartlistdata?.data?.result?.length || cartlistdata.data.result.length === 0) && (
                                    <>
                                        <img src={buyimg} alt="empty cart" className="cart-image-default mb-1" />
                                        <img src={buy1img} alt="hover cart" className="cart-image-hover yellow-filter mb-1" />
                                    </>
                                )}

                                {/* Show when cart has items */}
                                {cartlistdata?.data?.result?.length > 0 && (
                                    <>
                                        <img src={buy1img} alt="filled cart" className="cart-image-default yellow-filter mb-1" />
                                        <img src={buy1img} alt="hover cart" className="cart-image-hover yellow-filter mb-1" />
                                    </>
                                )}

                                {cartlistdata?.data?.result?.length > 0 && (
                                    <div className="cartcount">{cartlistdata.data.result.length}</div>
                                )}
                            </div>

                            {isBigScreen && (
                                <span
                                    className={`ps-1 ${cartlistdata?.data?.result?.length > 0
                                        ? 'cartcolor'
                                        : 'header-middle-right-title'
                                        }`}
                                >
                                    Cart
                                </span>
                            )}

                        </NavLink>



                    </div>
                </div>

                {/* Search in Mobile */}
                {!isBigScreen &&
                    <div className="mobile-header-search mt-1 mb-2">
                        {
                            window.location.pathname !== "/" &&
                            < img className="header-leftimg" src={leftimg} onClick={() => navigate(-1)}></img>
                        }
                        <Search />
                    </div>
                }

                {/* Location & Country in Mobile */}
                <div className="d-flex justify-content-between align-items-center">
                    {!isBigScreen && (
                        authstatus ? (
                            <NavLink to="/address" className="headertop-leftcorner delivertext cursor-pointer textdecoration-none">
                                <img src={'/assets/vector_icons/location.png'} className="headertop-icons" width={15} />
                                <span className="ps-1 headertoptitle" >Deliver to</span>
                                <span className="ps-1 currentlocation-address">
                                    {addressdata?.[0]?.address}
                                </span>
                            </NavLink>
                        ) : (
                            <div className="headertop-leftcorner">
                                <img src={'/assets/vector_icons/location.png'} className="headertop-icons" width={15} />
                                <span className="ps-1 headertoptitle">Deliver to</span>
                                <CurrentLocation />
                            </div>
                        )
                    )}
                    {!isBigScreen && <CountryDropdown countryDropdown={countryDropdown} />}
                </div>

            </div>

            {/* Bottom Navigation */}
            <div className="header-bottom-main">
                <div className="header-bottom homepagecontainer">
                    {!isBigScreen ? (
                        <div className="mobileAll-title">All</div>
                    ) : (
                        <div ref={dropdownRef}>
                            <Categorylist />
                        </div>
                    )}
                    <div className="header-mobile-bottom">
                        {
                            Object.keys(currentcountry).length > 0 && currentcountry?.nav_items.filter(({ status }) => status == 1).map((nav_item) => {
                                return (
                                    <NavLink
                                        to={nav_item.url}
                                        className={({ isActive }) =>
                                            `header-bottom-titles text-decoration-none ${window.location.pathname == nav_item.url ? 'active-link' : ''}`
                                        }
                                    >
                                        {nav_item.title}
                                    </NavLink>
                                )
                            })
                        }
                    </div>

                </div>
            </div>

            {/* Auth Modals */}
            {isBigScreen ? <Modal /> : <Mobileforms />}
        </div >
    );
};

export default Header;
